
import { sources } from "./sources";
import { getCachedState } from "../utils/stateContext";

const NON_SWITCH_AND_SAVE_STATES = (() => { try { return JSON.parse(process.env.REACT_APP_NON_SWITCH_AND_SAVE_STATES || '[]'); } catch { return []; } })();

const prodTestPlan = {
    name: 'Test Plan',
    title: 'Test Plan',
    startingAt: '1',
    total: '1',
    monthly_amount: '1',
    url: 'https://buy.stripe.com/14k02Y5sSaTEaFqeV9',
    price_id: 'price_1OIOHfBpdcZ3Pb9Q3WzGtARD',
    telegra_product_id: ''
}

const pricingBySource = 
{
    retail: {
        semaglutide : {
            injectable: {
                monthly : {
                    id: '1a9e4c4e-f410-42ae-9d52-b65e657e48bc',
                    name : 'Semaglutide Monthly - Injectable',
                    product: 'Semaglutide',
                    subscription_length: '1 Month',
                    title: 'Semaglutide Monthly',
                    formulation: 'injectable',
                    total: '230.00',
                    monthly_amount: '230.00',
                    price_id: 'price_1RrsK9BpdcZ3Pb9QEa3XA5RB',
                    telegra_product_id: 'pvt::761b8328-f642-41c8-bcdf-2768007ca056',
                    postback_amount: '125'
                },
                threeMonths : {
                    id: '66089d0d-0420-4eaa-80a2-31ed3b39ad75',
                    name : 'Semaglutide 3 Months - Injectable',
                    product: 'Semaglutide',
                    subscription_length: '3 Months',
                    title: 'Semaglutide 3 Months',
                    formulation: 'injectable',
                    total: '621.00',
                    monthly_amount: '207.00',
                    price_id: 'price_1RrsNNBpdcZ3Pb9QDcLZVAwd',
                    telegra_product_id: 'pvt::26c72a71-ac0a-44e5-9a99-66083fbedc9a',
                    postback_amount: '375'
                },
            },
            suspension: {
                monthly : {
                    id: '43961a0e-4be5-45b4-a5fd-fbe930de4333',
                    name : 'Semaglutide Monthly - Oral drops',
                    title: 'Semaglutide Monthly',
                    product: 'Semaglutide',
                    subscription_length: '1 Month',
                    formulation: 'suspension',
                    total: '230.00',
                    monthly_amount: '230.00',
                    price_id: 'price_1Ryg1fBpdcZ3Pb9QIbgVofdq',
                    telegra_product_id: 'pvt::5110dadc-f5ee-48bb-a9e9-3b7309e6aba8',
                    postback_amount: '125'
                },
                threeMonths : {
                    id: '6b4a63d1-93f8-43ae-9fd2-81bfdba2de2e',
                    name : 'Semaglutide 3 Months - Oral drops',
                    title: 'Semaglutide 3 Months',
                    product: 'Semaglutide',
                    subscription_length: '3 Months',
                    formulation: 'suspension',
                    total: '621.00',
                    monthly_amount: '207.00',
                    price_id: 'price_1RyfzFBpdcZ3Pb9Qm3M69R1w',
                    telegra_product_id: 'pvt::2fb22e2f-7b9a-44e0-9fdc-7d8ea3c39a3c',
                    postback_amount: '375'
                },
            }
        },
        tirzepatide : {
            injectable: {
                monthly : {
                    id: 'ca31bf1c-80cd-4f16-8db1-e990144800a4',
                    name : 'Tirzepatide Monthly - Injectable',
                    title: 'Tirzepatide Monthly',
                    product: 'Tirzepatide',
                    subscription_length: '1 Month',
                    formulation: 'injectable',
                    total: '397.00',
                    monthly_amount: '397.00',
                    price_id: 'price_1RrsLtBpdcZ3Pb9QNhtI8xf3',
                    telegra_product_id: 'pvt::d8c17df2-786f-4b56-9499-f1f85d09c06f',
                    postback_amount: '250'
                },
                threeMonths : {
                    id: 'c651de5c-5d6b-47dc-8ead-649ff5a659ad',
                    name : 'Tirzepatide 3 Months - Injectable',
                    title: 'Tirzepatide 3 Months',
                    product: 'Tirzepatide',
                    subscription_length: '3 Months',
                    formulation: 'injectable',
                    total: '1072.00',
                    monthly_amount: '357.00',
                    price_id: 'price_1RrsOaBpdcZ3Pb9Q70d0xYre',
                    telegra_product_id: 'pvt::9cc4a540-a48f-4c0c-80f9-214d5dd5dc44',
                    postback_amount: '500'
                },
            },
            suspension: {
                monthly : {
                    id: 'f0805c31-4806-448d-8631-5ff5d015707d',
                    name : 'Tirzepatide Monthly - Oral drops',
                    title: 'Tirzepatide Monthly',
                    product: 'Tirzepatide',
                    subscription_length: '1 Month',
                    formulation: 'suspension',
                    total: '397.00',
                    monthly_amount: '397.00',
                    price_id: 'price_1Ryg3ZBpdcZ3Pb9QLRbRJwmH',
                    telegra_product_id: 'pvt::71468b5e-4fd4-4846-bffc-31359fa57456',
                    postback_amount: '250'
                },
                threeMonths : {
                    id: '2b59911b-b833-437a-bc0e-4be6792488f1',
                    name : 'Tirzepatide 3 Months - Oral drops',
                    title: 'Tirzepatide 3 Months',
                    product: 'Tirzepatide',
                    subscription_length: '3 Months',
                    formulation: 'suspension',
                    total: '1072.00',
                    monthly_amount: '357.00',
                    price_id: 'price_1Ryg5DBpdcZ3Pb9Qh6P72wFG',
                    telegra_product_id: 'pvt::b02aec10-65ed-47aa-99b0-120dc209f337',
                    postback_amount: '500'
                },
            }
        },
        // Display prices for the /nad landing only: no Stripe price or Telegra
        // product yet, so these plans are not purchasable through checkout.
        nad : {
            injectable: {
                monthly : {
                    id: 'nad-injectable-monthly',
                    name : 'NAD+ Monthly - Injectable',
                    product: 'NAD+',
                    subscription_length: '1 Month',
                    title: 'NAD+ Monthly',
                    formulation: 'injectable',
                    total: '197.00',
                    monthly_amount: '197.00'
                },
                threeMonths : {
                    id: 'nad-injectable-3-months',
                    name : 'NAD+ 3 Months - Injectable',
                    product: 'NAD+',
                    subscription_length: '3 Months',
                    title: 'NAD+ 3 Months',
                    formulation: 'injectable',
                    total: '397.00',
                    monthly_amount: '132.33'
                },
            }
        },
        myStartClickUrl: 'https://qualify.mystarthealth.com/tb2-home-qualification-002?uid=35&oid=259&affid=104&utm_source=',
        coupons: [ 
            {
                name: 'Podcast',
                id: 'CnBKOncx',
                discount: 0.05
            }
        ]
    },
    test: {
        semaglutide : {
            injectable: {
                monthly : {
                    id: '345153da-c18b-4202-ae54-8194dcdb7111',
                    name : 'Semaglutide Monthly - Injectable',
                    title: 'Semaglutide Monthly',
                    product: 'Semaglutide',
                    subscription_length: '1 Month',
                    formulation: 'injectable',
                    total: '199.00',
                    monthly_amount: '199.00',
                    price_id: 'price_1RvikuBpdcZ3Pb9Q9XxFz43x',
                    telegra_product_id: 'pvt::4332bc52-5f54-4c8f-bf5c-f1ef2bb95fa0',
                    postback_amount: '125',
                    // third_month_price_id: 'price_1TOIjBBpdcZ3Pb9QOdn6OVwc'
                },
                threeMonths : {
                    id: 'e8b639af-9736-43cb-9a2b-ee365a8c7b49',
                    name : 'Semaglutide 3 Months - Injectable',
                    title: 'Semaglutide 3 Months',
                    product: 'Semaglutide',
                    subscription_length: '3 Months',
                    formulation: 'injectable',
                    total: '522.00',
                    monthly_amount: '174.00',
                    price_id: 'price_1RvilhBpdcZ3Pb9QfkGaUbOi',
                    telegra_product_id: 'pvt::4332bc52-5f54-4c8f-bf5c-f1ef2bb95fa0',
                    postback_amount: '375',
                    // first_quarter_price_id: 'price_1TOK59BpdcZ3Pb9Q5hKpk1nW',
                    // first_quarter_price: '348.00'
                },
            },
            suspension: {
                monthly : {
                    id: '693e18b4-f7fd-414d-8e5f-326faac302a4',
                    name : 'Semaglutide Monthly - Oral drops',
                    title: 'Semaglutide Monthly',
                    product: 'Semaglutide',
                    subscription_length: '1 Month',
                    formulation: 'suspension',
                    total: '199.00',
                    monthly_amount: '199.00',
                    price_id: 'price_1RxrVTBpdcZ3Pb9QVn2PGZoW',
                    telegra_product_id: 'pvt::4332bc52-5f54-4c8f-bf5c-f1ef2bb95fa0',
                    postback_amount: '125'
                },
                threeMonths : {
                    id: '1d6b247d-2b73-49c2-be4e-89871a9f44d8',
                    name : 'Semaglutide 3 Months - Oral drops',
                    title: 'Semaglutide 3 Months',
                    product: 'Semaglutide',
                    subscription_length: '3 Months',
                    formulation: 'suspension',
                    total: '522.00',
                    monthly_amount: '174.00',
                    price_id: 'price_1RxrWDBpdcZ3Pb9QQWzQ8ddA',
                    telegra_product_id: 'pvt::4332bc52-5f54-4c8f-bf5c-f1ef2bb95fa0',
                    postback_amount: '375'
                },
            }
        },
        tirzepatide : {
            injectable: {
                monthly : {
                    id: '157ecd97-0542-45f4-94b2-1ecba861a501',
                    name : 'Tirzepatide Monthly - Injectable',
                    title: 'Tirzepatide Monthly',
                    product: 'Tirzepatide',
                    subscription_length: '1 Month',
                    formulation: 'injectable',
                    total: '349.00',
                    monthly_amount: '349.00',
                    price_id: 'price_1RvimFBpdcZ3Pb9Qv5qlEQot',
                    telegra_product_id: 'pvt::b04cabe5-2acc-4b8c-aacd-eea3a48b65bb',
                    postback_amount: '250',
                    // third_month_price_id: 'price_1TOIjBBpdcZ3Pb9QOdn6OVwc'
                },
                threeMonths : {
                    id: '80e4eb3c-4321-414b-ac63-5e3ae8c8003b',
                    name : 'Tirzepatide 3 Months - Injectable',
                    title: 'Tirzepatide 3 Months',
                    product: 'Tirzepatide',
                    subscription_length: '3 Months',
                    formulation: 'injectable',
                    total: '993.00',
                    monthly_amount: '331.00',
                    price_id: 'price_1RvimZBpdcZ3Pb9Q67FgUQZ9',
                    telegra_product_id: 'pvt::b04cabe5-2acc-4b8c-aacd-eea3a48b65bb',
                    postback_amount: '500',
                    first_quarter_price_id: 'price_1P0ap4BpdcZ3Pb9QR6rNuPnM',
                    // first_quarter_price: '662.00'
                },
            },
            suspension: {
                monthly : {
                    id: '509246fd-45ce-4dfe-bc8e-4f31503e4ea0',
                    name : 'Tirzepatide Monthly - Oral drops',
                    title: 'Tirzepatide Monthly',
                    product: 'Tirzepatide',
                    subscription_length: '1 Month',
                    formulation: 'suspension',
                    total: '349.00',
                    monthly_amount: '349.00',
                    price_id: 'price_1RxrX0BpdcZ3Pb9QyXCSIk51',
                    telegra_product_id: 'pvt::b04cabe5-2acc-4b8c-aacd-eea3a48b65bb',
                    postback_amount: '250'
                },
                threeMonths : {
                    id: 'f5080ae2-ebaa-4917-a1af-03dd4277d9c1',
                    name : 'Tirzepatide 3 Months - Oral drops',
                    title: 'Tirzepatide 3 Months',
                    product: 'Tirzepatide',
                    subscription_length: '3 Months',
                    formulation: 'suspension',
                    total: '993.00',
                    monthly_amount: '331.00',
                    price_id: 'price_1RxrXkBpdcZ3Pb9QfIX4J6wI',
                    telegra_product_id: 'pvt::b04cabe5-2acc-4b8c-aacd-eea3a48b65bb',
                    postback_amount: '500'
                },
            }
        },
        myStartClickUrl: 'https://qualify.mystarthealth.com/tb2-ws-home-qualification-002?uid=36&oid=259&affid=104&utm_source=',
        coupons: [ 
            {
                name: 'Podcast',
                id: '0W6xK4VT',
                discount: 0.05
            }
        ]
    },
    wholesale: {
        semaglutide : {
            injectable: {
                monthly : {
                    id: '1dab66b1-43e3-42d7-3fa6-67455968222a',
                    name : 'Semaglutide Monthly - Injectable',
                    title: 'Semaglutide Monthly',
                    product: 'Semaglutide',
                    subscription_length: '1 Month',
                    formulation: 'injectable',
                    total: '149.00',
                    monthly_amount: '149.00',
                    price_id: 'price_1Tbt4oBpdcZ3Pb9QIzkpEFCx',
                    telegra_product_id: 'pvt::761b8328-f642-41c8-bcdf-2768007ca056',
                    postback_amount: '125',
                    third_month_price_id: 'price_1Tbt77BpdcZ3Pb9QlFrgNIQZ'
                },
                threeMonths : {
                    id: '004b6181-9a60-240d-4fba-3762125c6d55',
                    name : 'Semaglutide 3 Months - Injectable',
                    title: 'Semaglutide 3 Months',
                    product: 'Semaglutide',
                    subscription_length: '3 Months',
                    formulation: 'injectable',
                    total: '373.00',
                    monthly_amount: '124.00',
                    price_id: 'price_1Tc3faBpdcZ3Pb9QAmZeWTv0',
                    telegra_product_id: 'pvt::26c72a71-ac0a-44e5-9a99-66083fbedc9a',
                    postback_amount: '350',
                    first_quarter_price_id: 'price_1Tc3ezBpdcZ3Pb9Q1svTuv0Z',
                    first_quarter_price: '248.00'
                },
            },
            suspension: {
                monthly : {
                    id: '84db150f-42a8-46a9-88f3-ab7792b73aac',
                    name : 'Semaglutide Monthly - Oral drops',
                    title: 'Semaglutide Monthly',
                    product: 'Semaglutide',
                    subscription_length: '1 Month',
                    formulation: 'suspension',
                    total: '199.00',
                    monthly_amount: '199.00',
                    price_id: 'price_1SFdztBpdcZ3Pb9QAar4qYBj',
                    telegra_product_id: 'pvt::5110dadc-f5ee-48bb-a9e9-3b7309e6aba8',
                    postback_amount: '125'
                },
                threeMonths : {
                    id: 'e182965e-ec3a-4d08-b1ae-9b11bbcdde14',
                    name : 'Semaglutide 3 Months - Oral drops',
                    title: 'Semaglutide 3 Months',
                    product: 'Semaglutide',
                    subscription_length: '3 Months',
                    formulation: 'suspension',
                    total: '522.00',
                    monthly_amount: '174.00',
                    price_id: 'price_1S8knfBpdcZ3Pb9Qo1jQRQNe',
                    telegra_product_id: 'pvt::2fb22e2f-7b9a-44e0-9fdc-7d8ea3c39a3c',
                    postback_amount: '375'
                },
            }
        },
        tirzepatide : {
            injectable: {
                monthly : {
                    id: 'a376e01c-c321-9e3b-7ae4-bfa8bc355ab9',
                    name : 'Tirzepatide Monthly - Injectable',
                    title: 'Tirzepatide Monthly',
                    product: 'Tirzepatide',
                    subscription_length: '1 Month',
                    formulation: 'injectable',
                    total: '274.00',
                    monthly_amount: '274.00',
                    price_id: 'price_1Tc3hFBpdcZ3Pb9QCz12t7Yg',
                    telegra_product_id: 'pvt::d8c17df2-786f-4b56-9499-f1f85d09c06f',
                    postback_amount: '250',
                    third_month_price_id: 'price_1Tbt77BpdcZ3Pb9QlFrgNIQZ'
                },
                threeMonths : {
                    id: '858b2b64-25c5-be2b-9cc0-fd7b2ebc185d',
                    name : 'Tirzepatide 3 Months - Injectable',
                    title: 'Tirzepatide 3 Months',
                    product: 'Tirzepatide',
                    subscription_length: '3 Months',
                    formulation: 'injectable',
                    total: '747.00',
                    monthly_amount: '249.00',
                    price_id: 'price_1TbtHUBpdcZ3Pb9QJoLx6WFL',
                    telegra_product_id: 'pvt::9cc4a540-a48f-4c0c-80f9-214d5dd5dc44',
                    postback_amount: '450',
                    first_quarter_price_id: 'price_1TbtFiBpdcZ3Pb9QP6BjTMdX',
                    first_quarter_price: '498.00'
                },
            },
            suspension: {
                monthly : {
                    id: 'a40b3970-5034-47ff-b5a0-227d9b83c459',
                    name : 'Tirzepatide Monthly - Oral drops',
                    title: 'Tirzepatide Monthly',
                    product: 'Tirzepatide',
                    subscription_length: '1 Month',
                    formulation: 'suspension',
                    total: '349.00',
                    monthly_amount: '349.00',
                    price_id: 'price_1SFdvtBpdcZ3Pb9QgqHVV5e2',
                    telegra_product_id: 'pvt::71468b5e-4fd4-4846-bffc-31359fa57456',
                    postback_amount: '250'
                },
                threeMonths : {
                    id: '328a733f-717f-4d85-affe-6d4c6390cdcc',
                    name : 'Tirzepatide 3 Months - Oral drops',
                    title: 'Tirzepatide 3 Months',
                    product: 'Tirzepatide',
                    subscription_length: '3 Months',
                    formulation: 'suspension',
                    total: '993.00',
                    monthly_amount: '331.00',
                    price_id: 'price_1S8kvJBpdcZ3Pb9QrrNDyCjg',
                    telegra_product_id: 'pvt::b02aec10-65ed-47aa-99b0-120dc209f337',
                    postback_amount: '500'
                },
            }
        },
        myStartClickUrl: 'https://qualify.mystarthealth.com/tb2-home-qualification-002?uid=35&oid=259&affid=104&utm_source=',
        coupons: [ 
            {
                name: 'Podcast',
                id: 'CnBKOncx',
                discount: 0.05
            }
        ]
    }
};


function getPricing() {
    if (process.env.REACT_APP_TEST_PRICING === 'true') {
        return pricingBySource.test;
    }

    const source = localStorage.getItem('source');
    if (source && sources[source]?.wholesale) {
        const state = getCachedState();
        if (!state || state === 'Not available' || !NON_SWITCH_AND_SAVE_STATES.includes(state)) {
            return pricingBySource.wholesale;
        }
    }

    return pricingBySource.retail;
}

function getRetailPricing() {
    return pricingBySource.retail;
}

function isWholesalePricing() {
    if (process.env.REACT_APP_TEST_PRICING === 'true') {
        return false; // Test pricing is not considered wholesale
    }

    const source = localStorage.getItem('source');
    if (!source || !sources[source]?.wholesale) return false;
    const state = getCachedState();
    if (state && state !== 'Not available' && NON_SWITCH_AND_SAVE_STATES.includes(state)) return false;
    return true;
}

function calculateDiscount(retailPrice, wholesalePrice, withDecimals=false) {
    const retail = parseFloat(retailPrice);
    const wholesale = parseFloat(wholesalePrice);
    return withDecimals ? (retail - wholesale).toFixed(2) : (retail - wholesale).toFixed(0);
}

function calculateDiscountPercentage(retailPrice, wholesalePrice) {
    const retail = parseFloat(retailPrice);
    const wholesale = parseFloat(wholesalePrice);
    const discount = ((retail - wholesale) / retail * 100).toFixed(0);
    return discount;
}

function findPlanByPriceId(prices, priceId) {    
    for (let med in prices) {
        for (let formulation in prices[med]) {
            for (let period in prices[med][formulation]) {
                if (prices[med][formulation][period].price_id === priceId) {
                    return prices[med][formulation][period];
                }
            }
        }
    }
    return null;
}

function findPlanById(prices, id) {    
    for (let med in prices) {
        for (let formulation in prices[med]) {
            for (let period in prices[med][formulation]) {
                if (prices[med][formulation][period].id === id) {
                    return prices[med][formulation][period];
                }
            }
        }
    }
    return null;
}


function findPlans() {
    let items = [];
    let pricing = getPricing();
    function recurse(obj) {
        for (let key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                recurse(obj[key]);
            } else if (key === 'monthly' || key === 'threeMonths') {
                items.push(obj);
            }
        }
    }
    recurse(pricing);
    return items;
}

function findMonthlyPlans() {
    let items = [];
    let pricing = getPricing();
    function recurse(obj) {
        for (let key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                recurse(obj[key]);
            } else if (key === 'monthly') {
                items.push(obj);
            }
        }
    }
    recurse(pricing);
    return items;
}

function findThreeMonthPlans() {
    let items = [];
    let pricing = getPricing();
    function recurse(obj) {
        for (let key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                recurse(obj[key]);
            } else if (key === 'threeMonths') {
                items.push(obj);
            }
        }
    }
    recurse(pricing);
    return items;
}

/**
 * Get pricing options based on the product name
 * @param {string} product - 'semaglutide' or 'tirzepatide'
 * @return {object|null} - Returns the pricing object if found, otherwise null
 */
function getPricingOptionsByProductName(productName) {
    const pricing = getPricing();
    if (pricing[productName]) {
        return pricing[productName];
    }
    return null;
}

/**
 * Calculate the percentage savings when choosing a 3-month supply over a monthly supply
 * @param {string} monthlyPrice 
 * @param {string} threeMonthPrice 
 * @returns 
 */
function calculateQuarterlySavingsPercentage(monthlyPrice, threeMonthPrice) {
    const monthly = parseFloat(monthlyPrice);
    const threeMonth = parseFloat(threeMonthPrice);
    const quarterlySavings = (monthly * 3) - threeMonth;
    return ((quarterlySavings / (monthly * 3)) * 100).toFixed(0);
}

function getPlanByPriceId(priceId) {
    if (!priceId) return null;
    const prices = getPricing();
    return findPlanByPriceId(prices, priceId);
}

function Pricing() {
    return {
        getPrices: async () => {
            return getPricing();
        },
        getRetailPrices: () => {
            return getRetailPricing();
        },
        isWholesale: () => {
            return isWholesalePricing();
        },
        calculateDiscount: (retailPrice, wholesalePrice, withDecimals=false) => {
            return calculateDiscount(retailPrice, wholesalePrice, withDecimals);
        },
        calculateDiscountPercentage: (retailPrice, wholesalePrice) => {
            return calculateDiscountPercentage(retailPrice, wholesalePrice);
        },
        getPlan: (prices, priceId) => {
            return findPlanByPriceId(prices, priceId);
        },
        getPlans: () => {
            return findPlans();
        },
        getMonthlyPlans: () => {
            return findMonthlyPlans();
        },
        getThreeMonthPlans: () => {
            return findThreeMonthPlans();
        },
        getTestPlan: () => {
            return prodTestPlan;
        },
        getDefaultPlan: () => {
            return getPricing().semaglutide.injectable.monthly;
        },
        getPricingOptionsByProductName: (productName) => {
            return getPricingOptionsByProductName(productName);
        },
        calculateQuarterlySavingsPercentage: (monthlyPrice, threeMonthPrice) => {
            return calculateQuarterlySavingsPercentage(monthlyPrice, threeMonthPrice);
        },
        getPlanByPriceId: (priceId) => {
            return getPlanByPriceId(priceId);
        },
        getPlanById: (id) => {
            const prices = getPricing();
            return findPlanById(prices, id);
        }
    }
}

export default Pricing;